import ClientPatients from "./ClientPatients";
export default ClientPatients;